const DEAL_TYPE_LABELS = {
  sale: "Продаж",
  rent: "Оренда",
};

const PROPERTY_TYPE_LABELS = {
  apartment: "Квартира",
  house: "Будинок",
  land: "Земля",
  commercial: "Комерція",
  industrial: "Промислова",
};

const hasText = (value) =>
  typeof value === "string" && value.trim().length > 0;

const hasNumber = (value) => value !== null && value !== undefined && value !== "";

const formatPrice = (value) => {
  if (!hasNumber(value)) return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return `$${n.toLocaleString("uk-UA", { maximumFractionDigits: 0 })}`;
};

const formatRange = (min, max, formatter) => {
  const minStr = formatter(min);
  const maxStr = formatter(max);
  if (minStr && maxStr) return `${minStr} — ${maxStr}`;
  if (minStr) return `від ${minStr}`;
  if (maxStr) return `до ${maxStr}`;
  return null;
};

/**
 * Compact one-line summary for the Client list "Що шукає" column.
 * Returns null when client type is not buyer/both or preferences are empty.
 */
export function preferenceListSummary(client) {
  if (!client) return null;
  if (client.type !== "buyer" && client.type !== "both") return null;

  const prefs = client.preferences;
  if (!prefs) return null;

  const parts = [];
  const propertyTypeLabel = hasText(prefs.property_type)
    ? PROPERTY_TYPE_LABELS[prefs.property_type] || prefs.property_type
    : null;
  const dealTypeLabel = hasText(prefs.deal_type)
    ? DEAL_TYPE_LABELS[prefs.deal_type] || prefs.deal_type
    : null;
  const priceLabel = formatRange(prefs.min_price, prefs.max_price, formatPrice);
  const cityLabel = hasText(prefs.city) ? prefs.city : null;

  if (propertyTypeLabel) parts.push(propertyTypeLabel);
  if (dealTypeLabel) parts.push(dealTypeLabel);
  if (priceLabel) parts.push(priceLabel);
  if (cityLabel) parts.push(cityLabel);

  if (parts.length === 0) return null;
  return parts.join(" · ");
}

export function formatLastCommunication(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
}

export function formatMatchCount(matchesCount, newMatchesCount) {
  const total = Number(matchesCount) || 0;
  const fresh = Number(newMatchesCount) || 0;
  if (fresh > 0 && fresh < total) {
    return `${total} (${fresh} нов.)`;
  }
  return String(total);
}

export function formatOpenTasksCount(count) {
  return String(Number(count) || 0);
}
